/**
 * Dev only: pretend to be on mission N (1–14) without filing N-1 debriefs —
 * the dev menu sets it, and the screens that count filed missions (the vault
 * lock, the handler unlock, the key's first-mission crumble) read it.
 */
const KEY = "secret-missions-dev-mission";

export const devMissionNo = (): number | null => {
  if (!import.meta.env.DEV) return null;
  try {
    const n = Number(localStorage.getItem(KEY));
    return n >= 1 ? n : null;
  } catch {
    return null;
  }
};

export const setDevMissionNo = (n: number | null) => {
  try {
    if (n) localStorage.setItem(KEY, String(n));
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
};

/** Missions already filed: the dev override when set, else the real file. */
export const filedCount = (filed: unknown[]) => {
  const n = devMissionNo();
  return n ? n - 1 : filed.length;
};

/** Dev only: open the debrief with the key already earned, to get straight
 *  to the engraving (it is not a step of its own). Read once. */
let keyNext = false;
export const DEV_KEY_EVENT = "sm-dev-key";
export const devShowKeyNext = () => {
  keyNext = true;
  // already on the debrief (no remount to read the flag): tell it directly
  window.dispatchEvent(new Event(DEV_KEY_EVENT));
};
export const takeDevShowKey = () => {
  const k = import.meta.env.DEV && keyNext;
  keyNext = false;
  return k;
};
